import { Box, Card, Checkbox, IconButton, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { nodeReferences } from "../../../../../cra/stores/CraNodeStore";
import { CraNode } from "../../../../../cra/models/CraNode";
import { useStores } from "../../../../../shared/stores/RootStore";
import { ExpandIcon } from "../../../../../shared/views/icons";
import { NodePhoto } from "../../../../../shared/views/NodePhoto/NodePhoto";

const NodeItemBase = ({
  craNode,
  index,
  isChecked,
  onCheckboxChange,
  expandPhoto,
}: {
  craNode: CraNode;
  index: number;
  isChecked: boolean;
  onCheckboxChange: (
    nodeId: string,
    index: number,
    checked: boolean,
    shiftKey: boolean,
  ) => void;
  expandPhoto: () => void;
}) => {
  const { craNodeStore, mapStore } = useStores();

  const isSelected = craNode.id === craNodeStore.getSelected()?.id;
  const nodeReference = nodeReferences.get(craNode.id)!;

  const selectCraNode = () => {
    craNodeStore.select(craNode.id);
    mapStore.recenterMap();
  };

  const handleCheckboxClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();

    const nextChecked = !isChecked;
    const shiftKey = e.shiftKey === true;

    onCheckboxChange(craNode.id, index, nextChecked, shiftKey);
  };
  
  return (
    <Card.Root
      id={craNode.id}
      flexShrink={0}
      width="240px"
      overflow="hidden"
      outlineStyle="solid"
      outlineWidth={isSelected ? 3 : 0}
      outlineColor={isSelected ? "primary.300" : "transparent"}
    >
      <Stack gap={0}>
        <Box onClick={selectCraNode}>
          <NodePhoto node={craNode} />

          <IconButton
            size="sm"
            variant={"ghost"}
            colorPalette="primary"
            onClick={(e) => {
              e.stopPropagation();
              selectCraNode();
              expandPhoto();
            }}
            aria-label="Open Image"
            position="absolute"
            right={2}
            top={2}
          >
            <ExpandIcon />
          </IconButton>
        </Box>

        <Checkbox.Root
          p={2}
          value={craNode.id}
          checked={isChecked}
          colorPalette="primary"
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control onClick={handleCheckboxClick} />
          <Checkbox.Label>
            <Text fontSize="xs">
              <Text fontSize="sm" as="span" fontWeight="bold" mr={2}>
                #{nodeReference.index + 1}
              </Text>

              {moment(craNode.dateTime, "YYYY-MM-DD hh:mm:ss a").format(
                "MM/DD/YYYY HH:mm:ss",
              )}
            </Text>
          </Checkbox.Label>
        </Checkbox.Root>
      </Stack>
    </Card.Root>
  );
};

export const NodeItem = observer(NodeItemBase);
